import { useTranslation } from "react-i18next";

import { AppTextField } from "../../apps";
import React from "react";
import { Crypto } from "../../../types/models/Member";

interface Props {
  disabled: boolean;
  crypto?: Crypto;
}

const CryptoForm: React.FC<Props> = ({ disabled, crypto }) => {
  const { t } = useTranslation();
  return (
    <>
      <AppTextField
        placeholder={disabled ? crypto?.network : t("network")}
        name="cryptoNetwork"
        label={t("network")}
        disabled={disabled}
      />
      <AppTextField
        placeholder={disabled ? crypto?.address : t("cryptoAddress")}
        name="cryptoAddress"
        label={t("cryptoAddress")}
        disabled={disabled}
      />
    </>
  );
};

export default CryptoForm;
